import script from "./WorkbenchLeft.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkbenchLeft.vue?vue&type=script&setup=true&lang=js"

import "./WorkbenchLeft.vue?vue&type=style&index=0&id=29db5450&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29db5450"]])

export default __exports__